export default class Column {
  title = null

  field = null

  sorting = false

  defaultSort = false

  defaultSortOrder = null

  enabled = true

  render = row => (row[this.field] || '').toString()

  constructor(field, title, props) {
    this.title = title
    this.field = field
    this.initProps(props || {})
  }

  initProps({ ...props }) {
    for (const key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key)) {
        this[key] = props[key]
      }
    }
  }
}
